module.exports = __webpack_public_path__ + "static/media/IMG_4275.9a1ccfe2.PNG";